// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"participant-profile-questions__wrap--zaPGT"};